import React from 'react';
import Card from '../common/Card.jsx';

const Services = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Services</h1>
          <p className="text-gray-600 mt-1">Gestion des services proposés</p>
        </div>
        <button className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-all">
          <i className="fas fa-plus mr-2"></i>
          Nouveau Service
        </button>
      </div>

      <Card title="Services">
        <div className="text-center py-12">
          <i className="fas fa-concierge-bell text-6xl text-gray-300 mb-4"></i>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Services</h3>
          <p className="text-gray-600">Module en cours de développement</p>
        </div>
      </Card>
    </div>
  );
};

export default Services;